export default __webpack_public_path__ + "static/media/poly-grey-icon.ac0bc477.svg";